import { render, staticRenderFns } from "./BSAlert.vue?vue&type=template&id=0ffd4ca6&"
var script = {}
import style0 from "./BSAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports